<template>
  <v-container fluid fill-height id="container" ref="loginView" class="pa-0">
    <div class="mobile-splash-box">
      <div class="mobile-splash-img1"></div>
      <div class="mobile-splash-img2"></div>
    </div>
  </v-container>
</template>

<script>

export default {
  name: 'mobileSplash',
  components: {
  },
  data () {
    return {
      spotSeq: null,
      userId: '',
      userPassword: '',
      userPassShow: false,
      idSaveFlag: false,
      autoLoginFlag: false
    }
  },
  watch: {
  },
  mounted () {
    document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no')

    sessionStorage.removeItem('botw_access_info')

    this.$store.state.login.userSeq = null
    this.$store.state.login.userName = ''
    this.$store.state.login.userId = ''
    this.$store.state.login.spotSeq = null
    this.$store.state.login.spotName = null
    this.$store.state.login.loginKey = ''
    this.$store.state.login.encKey = ''
    this.$store.state.login.menuList = []
    this.$store.state.login.userGroupCodeKey = ''
    this.$store.state.login.userSpotList = []

    const self = this
    // 모바일 응답 - appInfoDetail
    window.appInfosMobile = function (flag, loginId, loginPw) {
      console.log('appInfosMobile', flag, loginId, loginPw)
      if (typeof flag === 'string') {
        // ios
        console.log('appInfosMobile (ios)', flag)
        const data = JSON.parse(flag)
        self.appInfosCallback(data)
      } else {
        // android
        const response = {
          autoLoginFlag: flag,
          loginId: loginId,
          loginPw: loginPw
        }
        console.log('appInfosMobile (android)', response.toString())
        self.appInfosCallback(response)
      }
    }

    this.$store.dispatch('mobile/getAppInfo')
  },
  created () {
  },
  methods: {
    infoBase64Encoding: function (data) {
      const CryptoJS = require('crypto-js')
      const info = CryptoJS.enc.Utf8.parse(data)
      return CryptoJS.enc.Base64.stringify(info)
    },
    infoBase64Decoding: function (data) {
      const CryptoJS = require('crypto-js')
      const info = CryptoJS.enc.Base64.parse(data)
      return info.toString(CryptoJS.enc.Utf8)
    },
    appInfosCallback: function (data) {
      // const data = JSON.parse(JSON.stringify(response.data))
      console.log('appInfosCallback', JSON.stringify(data))
      let encId = ''
      let encPw = ''
      if (data.autoLoginFlag) {
        encId = this.infoBase64Decoding(data.loginId)
        encPw = this.infoBase64Decoding(data.loginPw)
      }
      // this.idSaveFlag = data.idSaveFlag
      this.autoLoginFlag = data.autoLoginFlag
      this.userId = encId
      this.userPassword = encPw

      if (data.autoLoginFlag) {
        setTimeout(function () {
          this.loginSubmit()
        }.bind(this), 2500)
      } else {
        setTimeout(function () {
          const mainPath = '/visit/loginForm'
          this.$router.push({ path: mainPath })
        }.bind(this), 2500)
      }
    },
    loginSubmit: function () {
      console.log('loginSubmit : ', this.userId, this.userPassword)
      const CryptoJS = require('crypto-js')
      const Base64 = require('base-64')
      // 한글로 입력 시 콘솔에러 발생 조치_24.08.26_(unescape(encodeURIComponent(this.userId)))
      const encId = Base64.encode(unescape(encodeURIComponent(this.userId)))
      const cryptOptions = {}
      const iv = window.getHex(this.$store.state.basicEncIv)
      cryptOptions.iv = CryptoJS.enc.Hex.parse(iv)
      const key = window.getHex(this.$store.state.basicEncKey)
      // const encPw = CryptoJS.SHA512(this.userPassword).toString()
      const encPass = CryptoJS.AES.encrypt(this.userPassword, CryptoJS.enc.Hex.parse(key), cryptOptions).toString()

      // const encPw = CryptoJS.SHA512(this.userPassword).toString()
      const data = {
        userId: encId,
        userPass: encPass,
        checkId: this.userId,
        appFlag: true
      }
      if (data.userId !== '' && data.userPass !== '') {
        this.$store.dispatch('login', [data, this.loginSubmitCallback])
      }
    },
    loginSubmitCallback: function (response) {
      console.log('loginSubmitCallback :', JSON.parse(JSON.stringify(response.data)))
      if (response !== '' && response !== undefined && response.data !== '' && response.data !== undefined) {
        const data = response === undefined ? '' : response.data
        if (data !== '' && data !== undefined) {
          console.log('loginSubmitCallback : ', response.data)
          const success = response.data.success
          if (success) {
            // { userGroupCode: 1, userGroupName: '시스템관리자' },
            // { userGroupCode: 2, userGroupName: '현장관리자_홈넷' },
            // { userGroupCode: 3, userGroupName: '유지보수관리자' },
            // { userGroupCode: 4, userGroupName: '계약관리자' },
            // { userGroupCode: 5, userGroupName: '원격점검자' },
            // { userGroupCode: 6, userGroupName: '방문점검자' },
            // { userGroupCode: 7, userGroupName: '현장관리자_정보통신' }
            const userSeq = response.data.userSeq
            const userName = response.data.userName
            const userId = this.userId
            const pwdChangeFlag = response.data.pwdChangeFlag
            const loginKey = response.data.loginKey
            const encKey = response.data.encKey
            const compInfo = response.data.compInfo

            this.$store.state.login.userSeq = userSeq
            this.$store.state.login.userName = userName
            this.$store.state.login.userId = userId
            this.$store.state.login.pwdChangeFlag = pwdChangeFlag
            this.$store.state.login.loginKey = loginKey
            this.$store.state.login.encKey = encKey

            // this.$store.state.login.visitCompSeq = compInfo.visitCompSeq
            this.$store.state.visitCompSeq = compInfo.visitCompSeq
            this.$store.state.visitCompName = compInfo.visitCompName
            this.$store.state.autoLoginFlag = this.autoLoginFlag

            sessionStorage.setItem('botw_access_info', JSON.stringify({
              userSeq: this.$store.state.login.spotSeq,
              userName: userName,
              userId: userId,
              pwdChangeFlag: pwdChangeFlag,
              loginKey: loginKey,
              encKey: encKey,
              spotSeq: this.$store.state.login.spotSeq,
              spotName: this.$store.state.login.spotName
            }))

            // setAppInfo!!
            // this.$store.dispatch('mobile/setAppInfo', [this.idSaveFlag, this.userId])
            if (this.autoLoginFlag) {
              const encId = this.infoBase64Encoding(this.userId)
              const encPw = this.infoBase64Encoding(this.userPassword)
              this.$store.dispatch('mobile/setAppInfo', [this.autoLoginFlag, encId, encPw])
            } else {
              // this.$store.dispatch('mobile/setAppInfo', [this.autoLoginFlag, null, null])
              this.$store.dispatch('mobile/setAppInfo', [this.autoLoginFlag, '', ''])
            }

            const mainPath = '/botw/visit/main'
            this.$router.push({ path: mainPath })
          } else {
            console.log('mobile login success fail...')
            this.$store.state.login.userId = this.userId
            // success === false
            const msg = response.data.failMsg
            setTimeout(() => {
              this.$store.dispatch('snackbarShow', [msg, success])
            }, 150)
            setTimeout(() => {
              this.$router.push({ path: '/visit/loginForm' })
            }, 200)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.mobile-splash-box {display: flex;flex-direction: column;width: 100%;height: 100%;align-items: center;justify-content: space-between;padding: 10.42vh 0;}
.mobile-splash-img1 {background: url('~@/assets/images/mobile/title-splash.svg') no-repeat;width:26.38vw;height:14.77vh;background-size: contain;background-position: center center;margin-top: 9.38vh;}
.mobile-splash-img2 {background: url('~@/assets/images/mobile/img-splash.svg') no-repeat;width:calc(100vw - 27px - 27px);height:42vh;background-size: contain;background-position: center center;}
</style>
